import React from "react";
import { ColumnValueRendererProps } from "../table.data.interface";

const NumbersColumn = ({ columnData, isPreview }: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    !columnData?.value ||
    (!columnData.text && isPreview)
  ) {
    return null;
  }

  const value = isPreview ? columnData?.text : (columnData?.value as number);

  return <div>{value as number}</div>;
};

export default NumbersColumn;
